import React from 'react';
import withStyles from '@material-ui/styles/withStyles';
import { Typography, CircularProgress, Grid, Fade } from '@material-ui/core';

import { isLoading, useVisibilityTimeout } from '../utils';

const LoadingOverlay = ({
  text,
  size,
  classes,
  timeout,
  dataState,
  loading = isLoading(dataState),
}) => {
  const [visible] = useVisibilityTimeout(timeout);

  const displayContent = visible && loading;

  if (!displayContent) return null;

  return (
    <Fade in>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={classes.root}
      >
        <Grid item>
          <Grid container direction="column" alignItems="center">
            <Grid item>
              <CircularProgress size={size} color="secondary" />
            </Grid>
            <Grid item>
              <Typography color="secondary" variant="caption">
                {text}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fade>
  );
};

LoadingOverlay.defaultProps = {
  size: 25,
  timeout: 300,
  text: 'Loading...',
};

const styles = (theme) => ({
  root: {
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    position: 'absolute',
    zIndex: theme.zIndex.modal,
    color: theme.palette.common.white,
    background: `${theme.palette.common.black}0004d`,
  },
});

export default withStyles(styles, { name: 'LoadingOverlay' })(LoadingOverlay);
